<template>
    <users-current
        v-slot="{
            data: current_user
        }"
    >
        <users-find
            :params="{
                user: current_user.uuid,
                include: 'notification_preferences'
            }"
            v-slot="{
                data: user,
                is_loading,
                has_loaded,
                find,
                error: find_error
            }"
            @success="onFindSuccess"
        >
            <div v-if="!has_loaded || find_error">
                <base-loading
                    :error="find_error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="find_error"
                    :error="find_error"
                />
            </div>

            <users-update
                v-else
                :params="{
                    user: user.uuid
                }"
                v-slot="{
                    sid,
                    is_loading: is_saving,
                    update,
                    error: update_error
                }"
                @success="onUpdateSuccess"
                @error="onUpdateError"
            >
                <div class="mb-6 bg-white rounded shadow">
                    <header class="flex items-center px-4 border-b h-18 sm:px-6">
                        <h1 class="text-lg font-normal truncate">
                            Update Notification Preferences
                        </h1>
                    </header>

                    <div class="px-6 pt-6 border-b">
                        <validator-alert :sid="sid" />

                        <div class="text-grey-darker">
                            <p class="mb-4">
                                In order to receive notifications via SMS, you need to
                                <router-link
                                    :to="{
                                        name: $router.fix('dashboard.*.settings.telephone.edit')
                                    }"
                                    class="text-blue"
                                >
                                    add and verify your telephone number.
                                </router-link>
                            </p>
                        </div>
                    </div>

                    <base-form @submit="update(form)">
                        <table-ish>
                            <table-ish-row-header>
                                <table-ish-cell>
                                    When...
                                </table-ish-cell>
                                <table-ish-cell
                                    :shrink="true"
                                    class="px-0 text-center"
                                >
                                    Email
                                </table-ish-cell>
                                <table-ish-cell
                                    :shrink="true"
                                    class="pl-3 text-center"
                                >
                                    SMS
                                </table-ish-cell>
                            </table-ish-row-header>
                            <with-variables
                                v-for="field in form.notification_preferences"
                                :key="field.uuid"
                                :variables="{
                                    preference: _.find(user.notification_preferences.data, { uuid: field.uuid })
                                }"
                                v-slot="{
                                    preference
                                }"
                            >
                                <table-ish-row>
                                    <table-ish-cell :wrap="true">
                                        {{ preference.title }}

                                        <template slot="secondary">
                                            {{ preference.description }}
                                        </template>
                                    </table-ish-cell>
                                    <table-ish-cell
                                        :shrink="true"
                                        class="px-0 text-center"
                                    >
                                        <input-checkbox v-model="field.via_email" />
                                    </table-ish-cell>
                                    <table-ish-cell
                                        :shrink="true"
                                        class="pl-3 text-center"
                                    >
                                        <input-checkbox
                                            :disabled="!(user.telephone && user.telephone.is_verified)"
                                            v-model="field.via_sms"
                                        />
                                    </table-ish-cell>
                                </table-ish-row>
                            </with-variables>
                        </table-ish>

                        <base-form-footer class="rounded-b">
                            <base-button
                                :is-loading="is_saving"
                                type="submit"
                                class="w-full btn-blue md:w-auto"
                            >
                                Update Preferences
                            </base-button>
                        </base-form-footer>

                        <error-modal
                            v-if="update_error && $error.is(update_error, { exclude: [422] })"
                            :error="update_error"
                        />

                        <modal-success :is-open="show_updated_modal">
                            <template slot="heading">Email updated!</template>

                            <p>To complete your email update, please click the link on the email we've just sent you.</p>

                            <template slot="footer">
                                <div class="flex flex-col md:flex-row-reverse">
                                    <router-link
                                        :to="{
                                            name: $router.fix('dashboard.*.settings.index')
                                        }"
                                        class="text-center btn btn-green"
                                    >
                                        Go to Settings
                                    </router-link>
                                </div>
                            </template>
                        </modal-success>
                    </base-form>
                </div>
            </users-update>
        </users-find>
    </users-current>
</template>

<script>
    import _ from 'lodash'
    import scroll from '../../../../../support/scroll'
    import UsersCurrent from '../../../../../components/users-current'
    import UsersFind from '../../../../../components/users-find'
    import UsersUpdate from '../../../../../components/users-update'

    export default {
        components: {
            UsersCurrent,
            UsersFind,
            UsersUpdate
        },
        data () {
            return {
                show_updated_modal: false,
                form: {
                    notification_preferences: []
                }
            }
        },
        methods: {
            onFindSuccess ({ data: user }) {
                this.form.notification_preferences = _.map(user.notification_preferences.data, (preference) => {
                    return {
                        object: preference.object,
                        uuid: preference.uuid,
                        via_email: preference.via_email,
                        via_sms: preference.via_sms
                    }
                })
            },
            onUpdateSuccess ({ data: user }) {
                setTimeout(() => {
                    this.show_updated_modal = true
                }, 0)
            },
            onUpdateError () {
                scroll.toTop()
            }
        }
    }
</script>
